// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopoverCompactRow-moduleCalendarGridDayPopoverCompactRow__Pv7yM";
var _2 = "CalendarGridDayPopoverCompactRow-moduleclickable__q2Uik";
var _3 = "CalendarGridDayPopoverCompactRow-modulelabel__vkZvN";
var _4 = "CalendarGridDayPopoverCompactRow-modulestatus__MCTI7";
var _5 = "CalendarGridDayPopoverCompactRow-moduletime__aK1W4";
export { _1 as "CalendarGridDayPopoverCompactRow", _2 as "clickable", _3 as "label", _4 as "status", _5 as "time" }
